import React from 'react';
import { recoverLoginApi } from '../services/apiService'
import { showApiError, showApiSuccess } from "./utilities";
import {
  Form, Icon, Input, Button } from 'antd';


class RecoverPasswordForm extends React.Component {


  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      //if (!err) {
      //  console.log('Received values of form: ', values);
      //}
      let { Email } = values;
      let request = {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ Email })
      }
      //console.log(request) 

      function handleOKClick() {

        window.location.href = "/"
        return new Promise((resolve, reject) => {
          //setTimeout(resolve, 100);
          resolve();
        }).catch(() => console.log('Oops errors!'));

      }
      recoverLoginApi(request)
        .then(res => {
          if (res) {
            showApiSuccess("Your password has been reset. Please check your email for the new password. ", handleOKClick)
          } else {
            showApiError("Cannot find email.")
          }
        })
        .catch(err => {
          console.error(err)
        })
    })
  }


  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="Content">
        <div style={{ padding: 10 }}>
          <h2>Church Helper Online</h2>
        </div>
        <p>Enter your e-mail address below and we'll send you an e-mail message containing your new password.</p>
      <Form onSubmit={this.handleSubmit} className="login-form">
        <Form.Item>
          {getFieldDecorator('Email', {
            rules: [{ required: true, message: 'Please enter your email!' }],
          })(
            <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Email" />
          )}
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" className="login-form-button">
            Send 
          </Button>
        </Form.Item>
        </Form>
        </div>
    );
  }
}

const WrappedRecoverPasswordForm = Form.create({ name: 'normal_recover' })(RecoverPasswordForm);

export default WrappedRecoverPasswordForm;